import moment from "moment-timezone";
import { addDays, addMonths, differenceInCalendarDays, endOfDay, endOfMonth, endOfWeek, isSameDay, startOfDay, startOfMonth, startOfWeek, startOfYear, endOfYear, addYears } from 'date-fns';
import { FORMAT, APP, MONTH } from '../constant';
import { checkDate } from "./convert";

export const dateToString = (date, withTime) => {
    return moment(date ? new Date(date) : new Date()).format(withTime ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
}
export const stringToDate = (string, withTime) => {
    return new Date(moment(string, withTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')).getTime()
}

const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -6)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -6)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfCurrentYear: startOfYear(new Date()),
    endOfCurrentYear: endOfYear(new Date()),
    startOfNextYear: startOfYear(addYears(new Date(), 1)),
    endOfNextYear: endOfYear(addYears(new Date(), 1)),
    startOfLastYear: startOfYear(addYears(new Date(), -1)),
    endOfLastYear: endOfYear(addYears(new Date(), -1))
};
const staticRangeHandler = {
    range: {},
    isSelected(range) {
        const definedRange = this.range();
        return (
            isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate)
        );
    },
};

export function timeToMoment12Hours(value) {
    if (value) {
        let date = moment();
        let time = moment(value, ["h:mm A"]).format("HH:mm");
        let splitTime = time.split(':');
        if (splitTime?.length > 1) return date.set('hour', splitTime[0]).set('minute', splitTime[1]);
        else return null;
    } else return ''
}


export function getDiffrenceInMinute(start, end) {
    if (start && end && ![typeof start, typeof end]?.includes('number')) {
        start = start?.split(":");
        end = end?.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    } else {
        if (start && end) {
            return minutesToHm(end - start, true, true)
        }
    }
}

export const getTimeDifference = (start, end) => {
    if (start && end) {
        start = start.split(":");
        end = end.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    }
}

export const secondsToHms = (d, flag) => {
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (s < 10) s = '0' + s;
    if (flag) return `${h} H : ${m} M : ${s} S`;
    else return `${h}:${m}:${s}`;
}
export const secondsToHm = (d, flag) => {
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (flag) return `${h} H : ${m} M`;
    else return `${h}:${m}`;
}
export const checkPlusDay = (d1, date) => {
    d1 = moment(d1).set({ hour: 0, minute: 0, second: 0 })
    if (d1 && d1?.diff(date, 'day') > 0) return true;
    else return false;
}
export const getDate = (date, flag = 'start') => {
    const day = (date || date?.length !== 0) ? new Date(date) : new Date()
    return day.setHours(flag === 'start' ? 0 : 23, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 999);
}
export const timeDiff = (d1, d2) => {
    d1 = moment(d1);
    d2 = moment(d2);
    if (d1?.isSameOrBefore(d2)) return 1;
    else if (d1?.isSameOrBefore(moment())) {
        let duration = moment.duration(d1?.diff(d2));
        let hours = parseInt(duration.asHours());
        let minutes = parseInt(duration.asMinutes()) % 60;
        if (hours >= 0 && hours < 10) hours = "0" + hours;
        if (minutes >= 0 && minutes < 10) minutes = "0" + minutes;
        if (hours >= 0 || minutes >= 0) return `${hours} H : ${minutes} M`;
        else if (hours < 0 || minutes < 0) return 1;
    } else return 2;
};

export const setDate = (date, format) => {
    if (!date) return '';
    if (date.length === 0) return '';
    return moment(date).format(format);
};
export const getTimeStamp = () => ~~(Date.now() / 1000);
export const getDifference = (timestamp) => getTimeStamp() - timestamp;
export const convertTime = (secs = 0, format) => {
    if (!secs || secs === 0 || secs < 0) {
        if (format === 'hms') return '00h 00m 00s'
        else if (format === 'h:m:s') return '00:00:00'
        else if (format === 'h.m') return '00.00'
        else return '00h 00m'
    }
    const digit = d => d.toString().length === 1 ? `0${d}` : d;

    const h = digit(Math.floor(secs / (60 * 60)));

    const divisor_for_minutes = secs % (60 * 60);
    const m = digit(Math.floor(divisor_for_minutes / 60));

    const s = digit(Math.ceil(divisor_for_minutes % 60));

    if (format === 'hms') {
        if (h !== '00') return `${h}h ${m}m ${s}s`;
        else if (m !== '00') return `00h ${m}m ${s}s`;
        else return `00h 00m ${s}s`;
    } else if (format === 'h:m:s') {
        if (h !== '00') return `${h}:${m}:${s}`;
        else if (m !== '00') return `00:${m}:${s}`;
        else return `00:00:${s}`;
    } else if (format === 'h.m') {
        return (secs / 60 / 60).toFixed(2)
    } else {
        if (h !== '00') return `${h}h ${m}m`;
        else if (m !== '00') return `00h ${m}m`;
        else return `00h 00m`;
    }
}
export const convertTimeSheet = (secs = 0, format) => {
    let prefix = ''
    if (secs < 0) {
        prefix = '-'
        secs = secs * -1
    }
    const digit = d => d.toString().length === 1 ? `0${d}` : d;

    const h = digit(Math.floor(secs / (60 * 60)));

    const divisor_for_minutes = secs % (60 * 60);
    const m = digit(Math.floor(divisor_for_minutes / 60));

    const s = digit(Math.ceil(divisor_for_minutes % 60));

    if (format === 'hms') {
        if (h !== '00') return `${prefix}${h}H:${m}M:${s}S`;
        else if (m !== '00') return `${prefix}00H:${m}M:${s}S`;
        else return `${prefix}00H:00M:${s}S`;
    } else if (format === 'h:m:s') {
        if (h !== '00') return `${prefix}${h}:${m}:${s}`;
        else if (m !== '00') return `${prefix}00:${m}:${s}`;
        else return `${prefix}00:00:${s}`;
    } else if (format === 'h.m') {
        return `${prefix}${(secs / 60 / 60).toFixed(2)}`
    } else if(format === 'h,m,s'){
        if (h !== '00' && m !== '00') return `${prefix}${h}H:${m}M`;
        else if (h !== '00') return `${prefix}${h} H`;
        else if (m !== '00') return `${prefix}${m} M`;
    } else {
        if (h !== '00') return `${prefix}${h}H:${m}M`;
        else if (m !== '00') return `${prefix}00H:${m}M`;
        else return `${prefix}00H:00M`;
    }
}
export const convertTimeNumberToString = (sec) => {
    let hours = Math.floor(sec / 3600);
    (hours >= 1) ? sec = sec - (hours * 3600) : hours = '00';
    hours = hours > 9 ? "" + hours : "0" + hours;
    let min = Math.floor(sec / 60);
    (min >= 1) ? sec = sec - (min * 60) : min = '00';
    (sec < 1) ? sec = '00' : void 0;

    (min.toString().length === 1) ? min = '0' + min : void 0;
    return hours + ':' + min;
}
export const getSplitTime = (time) => {
    const converTime = convertTimeNumberToString(time)
    if (!converTime) return '00h 00m'
    const split = converTime.split(':')
    if (split.length === 2 && split[0] === "") return `00h ${split[1]}m`;
    else if (split.length === 2 && split[1] === "") return `${split[0]}h 00m`;
    else return `${split[0]}h ${split[1]}m`
}

export function createStaticRanges(ranges) {
    return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
    {
        label: 'Today',
        range: () => ({
            startDate: defineds.startOfToday,
            endDate: defineds.endOfToday,
        }),
    },
    {
        label: 'Yesterday',
        range: () => ({
            startDate: defineds.startOfYesterday,
            endDate: defineds.endOfYesterday,
        }),
    },
    {
        label: 'Last Week',
        range: () => ({
            startDate: defineds.startOfLastWeek,
            endDate: defineds.endOfLastWeek,
        }),
    },
    {
        label: 'Last Month',
        range: () => ({
            startDate: defineds.startOfLastMonth,
            endDate: defineds.endOfLastMonth,
        }),
    },
    {
        label: 'Current Year',
        range: () => {
            return {
                startDate: defineds.startOfCurrentYear,
                endDate: defineds.endOfCurrentYear,
            }
        },
        rangeType: true
    },
    {
        label: 'Last Year',
        range: () => {
            return {
                startDate: defineds.startOfLastYear,
                endDate: defineds.endOfLastYear,
            }
        },
        rangeType: true
    },
    {
        label: 'Next Year',
        range: () => {
            return {
                startDate: defineds.startOfNextYear,
                endDate: defineds.endOfNextYear,
            }
        },
        rangeType: true
    },
]);
export const defaultInputRanges = [
    {
        label: 'days up to today',
        range(value) {
            return {
                startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: defineds.endOfToday,
            };
        },
        getCurrentValue(range) {
            if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
            if (!range.startDate) return '∞';
            return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
        },
    }
];
export const showFilterDateRange = (date = [], filterName = 'Date') => {
    const filterStartDate = date?.[0]?.startDate
        ? moment(date?.[0]?.startDate).format('D MMM YY')
        : `Select ${filterName}`;

    let filterEndDate = date?.[0]?.endDate
        ? moment(date?.[0]?.endDate).format('D MMM YY')
        : `Select ${filterName}`;

    filterEndDate = filterStartDate === filterEndDate ? '' : ` - ${filterEndDate}`;

    return date?.length > 0 ? `${filterName}: ${filterStartDate}${filterEndDate}` : filterName;
}
export const compareFilterDates = (date, newDate) => {
    let filteredDates = JSON.parse(date);
    let isMatch = dateFormatter({
        date: filteredDates?.[0]?.startDate, format: 'DD/MM/YYYY'
    }) === dateFormatter({
        date: newDate?.[0]?.startDate, format: 'DD/MM/YYYY'
    }) && dateFormatter({
        date: filteredDates?.[0]?.endDate, format: 'DD/MM/YYYY'
    }) === dateFormatter({
        date: newDate?.[0]?.endDate, format: 'DD/MM/YYYY'
    });
    return isMatch ? '' : 1;
}
const DAY_PIPE_FORMAT = {
    default: { today: FORMAT.TIME, week: FORMAT.DAY_TIME, full: FORMAT.DATE_TIME, time: FORMAT.TIME },
    hrms:    { today: FORMAT.DAY_DATE_MONTH, week: FORMAT.DAY_DATE_MONTH, full: FORMAT.DAY_DATE_MONTH, time: FORMAT.TIME },
    assets:  { today: FORMAT.DAY_DATE_MONTH, week: FORMAT.DAY_DATE_MONTH, full: FORMAT.DAY_DATE_MONTH, time: FORMAT.DAY_DATE_MONTH },
    survey:  { today: FORMAT.DAY_DATE_MONTH, week: FORMAT.DAY_DATE_MONTH, full: FORMAT.DAY_DATE_MONTH, time: FORMAT.TIME },
};

export const dayPipe = (date, flag, module = 'default') => {
    const F = DAY_PIPE_FORMAT[module] || DAY_PIPE_FORMAT.default;
    const DATE = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    if (flag === 'comment') {
        if (DATE.isSame(REFERENCE, 'week')) {
            // Check if date is today, yesterday, weekday or others
            const m = parseInt(moment.duration(REFERENCE.diff(DATE)).asMinutes());
            if (m < 2) return `Just now`;
            else if (m < 60) return `${m} minutes ago`;
            else if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(F.today)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(F.today)}`;
            else return DATE.format(F.week);
        } else return DATE.format(F.full);
    } else if (flag === 'time') {
        // If you want only time from date object
        return DATE.format(F.time);

    } else if (flag === 'date') {

        // If you want only date from date object (literal labels unchanged across modules)
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return DATE.format(FORMAT.TIME);
            else if (DATE.isSame(YESTERDAY, 'd')) return 'Yesterday';
            else return DATE.format('dddd');

        } else return DATE.format(FORMAT.DATE);
    } else {

        // If you want only date and time both from date object
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(F.today)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(F.today)}`;
            else return DATE.format(F.week);

        } else return DATE.format(F.full);
    }
};

export const getDateList = (s, e) => {
    for (var a = [], d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + 1)) {
        a.push(moment(new Date(d)).format(FORMAT.DATE));
    }
    return a;
}
export const getUTC = (date = new Date(), flag) => {
    const convertedDate = moment.utc(date)
    if (flag === 'start') convertedDate.startOf('day')
    if (flag === 'end') convertedDate.endOf('day')
    return moment.utc(convertedDate).format()
}
export const toISOIgnoreTimezone = (inputDate) => {
    return inputDate.getFullYear() + "-" +
        ("0" + (inputDate.getMonth() + 1)).slice(-2) + "-" +
        ("0" + inputDate.getDate()).slice(-2) + "T00:00:00.000Z";
}
export const utcDueDate = (date) => moment(date).format(FORMAT.TIME) !== '12:00 AM' ? getUTC(date) : toISOIgnoreTimezone(date)
export const getDateTime = (selectedDate, withTime = false) => {
    if (!selectedDate) return ''
    const dateString = checkDate(selectedDate)
    const date = moment.utc(selectedDate).format(withTime ? FORMAT.DATE : FORMAT.DUE_DATE)
    const time = moment(selectedDate).format(FORMAT.TIME)
    const showTime = moment.utc(selectedDate).format(FORMAT.TIME)
    const show = withTime && showTime !== '12:00 AM'

    if (dateString === 'Today' || dateString === 'Yesterday' || dateString === 'Tomorrow') return show ? `${dateString} ${time}` : dateString
    else if (dateString === 'Older' || dateString === 'Upcoming' || dateString === 'This Month' || dateString === 'This Week' || dateString === 'No Due Date') return show ? `${date} ${time}` : date
    else return ''
}
export const parseDateTime = {
    dueDate: (date) => date ? new Date(date) : date,
    dueTime: (date) => {
        const showTime = moment.utc(date ? new Date(date) : date).format(FORMAT.TIME)
        return showTime !== '12:00 AM' ? (date ? moment(date) : date) : null
    },
    dueDayTime: (time) => {
        const showTime = moment(time, "hh:mm A").format("hh:mm A");
        return showTime !== '12:00 AM' ? moment(time, "hh:mm A") : null;
    }
}

export function minutesToNumberString(value, isHM) {
    if (value <= 1440) {
        let hour = Math.floor(parseFloat(Math.abs(value)) / 60)?.toString()?.padStart(2, '0') || "00";
        let minute = Math.round(parseFloat(Math.abs(value)) % 60)?.toString()?.padStart(2, '0') || "00";
        if (isHM) return `${hour}H:${minute}M`
        return hour + ":" + minute || "00:00";
    } else return "00:00"
}

export function hourToMinute(value) {
    /**
     * value must be in HH:MM
     * */
    if (value && typeof value === 'string') return Math.floor(Number(value?.split(":")[0]) * 60 + Number(value?.split(":")[1]));
    else if (typeof value === "number") return minutesToNumberString(value)
    else return 0
}

export function stringToTime(value, format = "HH:mm") {
    if (value) {
        let date = new Date();
        let time = moment(value, [format]).format("HH:mm");
        let splitTime = time.split(':');
        date.setHours(splitTime[0])
        date.setMinutes(splitTime[1])
        date.setSeconds(0)
        date.setMilliseconds(0)
        if (splitTime?.length > 1) return date;
        else return null;
    } else return ''
}

export const minutesToHm = (d, flag, isHrs = false) => {
    let isNegative = (Math.sign(d) === -1) ? true : false;
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 60);
    /** need precision in minutes but not in hours so round method selected if we select floor it will loose 1 minute.*/
    let m = Math.round(d % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (flag === 'payroll') return `${h}H: ${m}M`;
    if (isHrs) {
        return `${h} Hrs : ${m} Mins`
    }
    if (flag && isNegative) {
        return `-${h}H : ${m}M`
    } else if (flag) {
        return `${h}H : ${m}M`
    } else return `${h}:${m}`;
}

export function minutesTo12Hour(minutes = 0) {
    return timeToMoment12Hours(minutesToHm(minutes)).format('h:mm A') || "12:00AM"
}

export const getYearList = (endYear, startYear) => {
    const currentYear = new Date().getFullYear();
    const fromYear = startYear ?? currentYear;
    const toYear = endYear ?? 1950;

    const yearList = [];

    const step = fromYear >= toYear ? -1 : 1;

    for (let year = fromYear; step === -1 ? year >= toYear : year <= toYear; year += step) {
        yearList.push({ label: year.toString(), value: year });
    }

    return yearList;
}

// DST-aware: returns the UTC offset in minutes for a timezone at a given date
// e.g., "America/New_York" → -300 (standard) or -240 (DST)
export const getOffset = (timezone, date) => {
    if (!timezone?.length) return 0;
    try {
        return -moment.tz(date || new Date(), timezone).utcOffset();
    } catch (e) {
        return 0;
    }
};
export const getLocalTimezone = () => Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
export const getTimezone = (timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) => {
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
    // DST-aware: compare current offsets for both timezones
    return moment.tz(timezone).utcOffset() === moment.tz(localTimezone).utcOffset() ? '' : timezone
}
export const dateOrdinal = (date, d1, timezone = APP.DEFAULT_TZ) => {
    const date1 = moment.tz(date, APP.DEFAULT_TZ).clone().format('DD-MM-YYYY')
    const date2 = moment.tz(d1, timezone).clone().format('DD-MM-YYYY')
    if (moment(date1, 'DD-MM-YYYY').isAfter(moment(date2, 'DD-MM-YYYY'), 'day')) {
        return "-1 Day";
    } else if (moment(date1, 'DD-MM-YYYY').isBefore(moment(date2, 'DD-MM-YYYY'), 'day')) {
        return "+1 Day";
    } else {
        return "";
    }
}
/**
 * getIST => localToIST
 * getISTDate => localToIST
 *
 * showIST => istToLocal
 * getLocalDate => istToLocal
 *
 * formatDate => dateFormatter
 * formatTimezone = dateFormatter
 * */
export const dateFormatter = ({
                                  date,
                                  format = FORMAT.DAY_DATE_MONTH,
                                  timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
                              }) => (date ? moment.tz(date, timezone).format(format) : '-')
// To get local timezone string: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone

// DST-aware: converts a date from one timezone to another (preserves wall-clock time)
// e.g., 10:00 AM in "Asia/Kolkata" → 10:00 AM in "America/New_York"
export const considerTimezone = ({
                               date = new Date(),
                              from = APP.DEFAULT_TZ,
                              to = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
                           } = {}) => {
    // Interpret the epoch in the 'from' timezone and extract wall-clock
    const m = moment.tz(new Date(date).getTime(), from);
    const wallClock = m.format('YYYY-MM-DDTHH:mm:ss.SSS');
    // Reinterpret the same wall-clock in the 'to' timezone
    return new Date(moment.tz(wallClock, to).valueOf());
};

// DST-aware: converts a local date to IST (Asia/Kolkata) timestamp (preserves wall-clock)
// e.g., midnight EDT → midnight IST (same wall-clock, different epoch)
export const localToIST = (date, flag = 'start') => {
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
    let m = moment.tz(date, localTimezone);

    if (flag === 'start') {
        m = m.startOf('day');
    } else if (flag === 'end') {
        m = m.endOf('day');
    }

    // Extract wall-clock from local timezone, reinterpret as IST
    const wallClock = m.format('YYYY-MM-DDTHH:mm:ss.SSS');
    return moment.tz(wallClock, APP.DEFAULT_TZ).valueOf();
};

// DST-aware: converts an IST (Asia/Kolkata) date to local timezone timestamp (preserves wall-clock)
// e.g., midnight IST → midnight local (same wall-clock, different epoch)
export const istToLocal = (date, flag = 'start') => {
    let m = moment.tz(date, APP.DEFAULT_TZ);

    if (flag === 'start') {
        m = m.startOf('day');
    } else if (flag === 'end') {
        m = m.endOf('day');
    }

    // Extract wall-clock from IST, reinterpret in local timezone
    const localTimezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
    const wallClock = m.format('YYYY-MM-DDTHH:mm:ss.SSS');
    return moment.tz(wallClock, localTimezone).valueOf();
};

export function formatAMPM(date) {
    let hours = date.getHours();
    let ampm = hours >= 12 ? ' pm' : ' am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return hours + ampm;
}

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));

export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

export const momentToValueOf = (date) => {
    return moment(date).valueOf()
}

export const timeStampUnix = (date) => {
    return moment(date).valueOf()
}

export const dateTimeFormat = (date, format) => {
    return moment(date).format(format)
}

export const getDateOfMonth = (month, year, day) => new Date(year, month, day);

export const generateYearList = (baseYear = 2021, futureYears = 0) => {
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear + futureYears;
    const years = [];
    for (let year = lastYear; year >= baseYear; year--) {
        years.push({ label: year, value: year });
    }
    return years;
};

export const getCurrentFinancialYear = (date) => {
    let year = "";
    let today = date ? new Date(date) : new Date();
    if ((today.getMonth() + 1) <= 3) {
        year = (today.getFullYear() - 1) + " - " + today.getFullYear()
    } else {
        year = today.getFullYear() + " - " + (today.getFullYear() + 1)
    }
    return year
}

// ===== migrated from pms/src/common/functions/common.jsx =====
export const convertTimeToDecimal = (timeString) => {
    // Extract hours and minutes using regex
    const regex = /(\d+)H:(\d+)M/;
    const match = timeString.match(regex);

    if (match) {
        const hours = parseInt(match[1], 10); // Get the hours part
        const minutes = parseInt(match[2], 10); // Get the minutes part

        // Convert minutes to decimal (1 hour = 60 minutes)
        const decimalHours = hours + (minutes / 60);
        return decimalHours;
    } else {
        throw new Error("Invalid time format");
    }
};

export const convertTimeWithoutHM = (secs = 0) => {
    let prefix = '';
    if (secs < 0) {
        prefix = '-';
        secs = secs * -1;
    }
    const digit = d => d.toString().length === 1 ? `0${d}` : d;

    const h = digit(Math.floor(secs / (60 * 60)));
    const divisor_for_minutes = secs % (60 * 60);
    const m = digit(Math.floor(divisor_for_minutes / 60));

    return `${prefix}${h}:${m}`; // Format without "H" or "M"
}

export const convertTimeStringToNumber = (estimatedTime) => {
    if (typeof estimatedTime != 'string') {
        if (typeof estimatedTime == 'number')
            return estimatedTime;
        else
            return 0;
    }

    estimatedTime = estimatedTime.trim();
    let splitted = estimatedTime.split(':');
    let hour = !isNaN(splitted[0]) ? Number(splitted[0]) : 0, minute = !isNaN(splitted[1]) ? Number(splitted[1]) : 0;

    return (hour * 60 * 60) + (minute * 60);
}

export const convertSecToMin = (value, flag) => flag === 's' ? (Number(value) * 60 * 60) : (Number(value) / 60 / 60)

export const getDaysLength = (date1, date2) => {
    const singleDay = 24 * 60 * 60 * 1000
    return Math.ceil((new Date(date2).getTime() - new Date(date1).getTime()) / singleDay)
}

export const getDates = (startDate, endDate) => {
    const dates = []
    let currentDate = startDate
    const addDays = function (days) {
        const date = new Date(this.valueOf())
        date.setDate(date.getDate() + days)
        return date
    }
    while (currentDate <= endDate) {
        dates.push(currentDate)
        currentDate = addDays.call(currentDate, 1)
    }
    // moment(dates).toISOString(true)
    return dates
}

export const getDataFromDates = (endDate, startDate, steps = 1) => {
    let dates = [];
    const start_date = new Date(new Date(startDate).setHours(0, 0, 0, 0));
    const end_date = new Date(new Date(endDate).setHours(0, 0, 0, 0));

    while (start_date < end_date) {
        dates = [...dates, new Date(start_date).getTime()];
        start_date.setDate(start_date?.getDate() + 1);
    }
    dates = [...dates, new Date(end_date).getTime()];

    return dates;
}

export const getDaysWeekWise = (days, flag) => {
    let tempDays = [];
    const groups = days.reduce((acc, date) => {


        // create a composed key: 'year-week'
        let yearWeek = []
        if (flag === 'month') yearWeek = `${moment.utc(date).year()}-${moment.utc(date).month()}`;
        if (flag === 'week') yearWeek = `${moment.utc(date).year()}-${moment.utc(date).week()}`;
        // add this key as a property to the result object
        if (!acc[yearWeek]) {
            acc[yearWeek] = [];
        }
        // push the current date that belongs to the year-week calculated befor
        acc[yearWeek].push(date);
        return acc;
    }, {});
    Object.keys(groups)?.map((key) => {
        // let maxWorkingHour = 0, workLoad = 0;
        // groups[key]?.map((ele) => {
        //     maxWorkingHour += days[ele]?.maxWorkingHour || 0;
        //     workLoad += days[ele]?.workLoad || 0;
        // })
        let minWeekDate = new Date(Math.min.apply(null, groups[key]?.map((e) => new Date(e))));
        tempDays.push(minWeekDate)
        // console.log('>>>>>>>>>>>>>>>> ', tempDays)
    });
    return tempDays;
}

export const filterByDate = (type, startDate = 0, endDate = 0) => {
    let dateFilter = {}
    switch (type) {
        case "TODAY":
            dateFilter = {
                start: new Date(moment().clone().startOf('day')),
                end: new Date(moment().clone().endOf('day'))
            }
            break
        case "YESTERDAY":
            dateFilter = {
                start: new Date(moment().clone().subtract(1, 'day').startOf('day')),
                end: new Date(moment().clone().subtract(1, 'day').endOf('day'))
            }
            break
        case "NEXT_DAY":
            dateFilter = {
                start: new Date(moment().clone().add(1, 'day').startOf('day')),
                end: new Date(moment().clone().add(1, 'day').endOf('day'))
            }
            break
        case "THIS_WEEK":
            dateFilter = {
                start: new Date(moment().clone().startOf('week')),
                end: new Date(moment().clone().endOf('week'))
            }
            break
        case "NEXT_WEEK":
            dateFilter = {
                start: new Date(moment().clone().add(1, 'week').startOf('week')),
                end: new Date(moment().clone().add(1, 'week').endOf('week'))
            }
            break
        case "LAST_WEEK":
            dateFilter = {
                start: new Date(moment().clone().subtract(1, 'week').startOf('week')),
                end: new Date(moment().clone().subtract(1, 'week').endOf('week'))
            }
            break
        case "THIS_MONTH":
            dateFilter = {
                start: new Date(moment().clone().startOf('month')),
                end: new Date(moment().clone().endOf('month'))
            }
            break
        case "LAST_MONTH":
            dateFilter = {
                start: new Date(moment().clone().subtract(1, 'month').startOf('month')),
                end: new Date(moment().clone().subtract(1, 'month').endOf('month'))
            }
            break
        case "THIS_YEAR":
            dateFilter = {
                $gt: new Date(moment().clone().startOf('year')),
                end: new Date(moment().clone().endOf('year'))
            }
            break
        case "LAST_YEAR":
            dateFilter = {
                start: new Date(moment().clone().subtract(1, 'year').startOf('year')),
                end: new Date(moment().clone().subtract(1, 'year').endOf('year'))
            }
            break
        case "LAST_30_DAY":
            dateFilter = {
                start: new Date(moment().clone().subtract(30, 'day')),
                end: new Date(moment())
            }
            break
        case "CUSTOM_DATE":
            dateFilter = {
                start: new Date(startDate),
                end: new Date(endDate)
            }
            break
        case "CUSTOM_THIS_MONTH":
            dateFilter = {
                start: new Date(moment(new Date(startDate).toISOString()).clone().startOf('month')),
                end: new Date(moment(new Date(startDate).toISOString()).clone().endOf('month'))
            }
            break
        case "CURRENT_AND_NEXT_WEEK":
            dateFilter = {
                start: new Date(moment().startOf('week')),
                end: new Date(moment().add(1, 'weeks').endOf('week'))
            }
            break
        case "NEXT_MONTH":
            dateFilter = {
                start: new Date(moment(startDate).add(1, 'months').startOf('month').toISOString()),
                end: new Date(moment(startDate).add(1, 'months').endOf('month').toISOString())
            };
            break;
        default:
            break
    }

    return dateFilter;
}

export const getFilterDate = (type, startDate = 0, endDate = 0) => {
    moment.updateLocale('en', {
        week: {
            dow: 1, // 0 is Sunday, 1 is Monday, etc.
        }
    });
    let dateFilter = {}
    switch (type) {
        case "THIS_WEEK":
            dateFilter = {
                start: new Date(moment().clone().startOf('week')),
                end: new Date(moment().clone().endOf('week'))
            }
            break
        case "THIS_MONTH":
            dateFilter = {
                start: new Date(moment().clone().startOf('month')),
                end: new Date(moment().clone().endOf('month'))
            }
            break
        case "CURRENT_AND_NEXT_WEEK":
            dateFilter = {
                start: new Date(moment().startOf('week')),
                end: new Date(moment().add(1, 'weeks').endOf('week'))
            }
            break
        case "NEXT_MONTH":
            dateFilter = {
                start: new Date(moment(startDate).add(1, 'months').startOf('month').toISOString()),
                end: new Date(moment(startDate).add(1, 'months').endOf('month').toISOString())
            };
            break;
        case "PREVIOUS_MONTH":
            dateFilter = {
                start: new Date(moment(startDate).subtract(1, 'months').startOf('month').toISOString()),
                end: new Date(moment(startDate).subtract(1, 'months').endOf('month').toISOString())
            };
            break;
        case "NEXT_1_WEEKS":
            dateFilter = {
                start: new Date(moment(startDate).add(1, 'weeks').startOf('day').toISOString()),
                end: new Date(moment(endDate).add(1, 'weeks').endOf('day').toISOString())
            }
            break
        case "NEXT_2_WEEKS":
            dateFilter = {
                start: new Date(moment(startDate).add(2, 'weeks').startOf('day').toISOString()),
                end: new Date(moment(endDate).add(2, 'weeks').endOf('day').toISOString())
            }
            break;
        case "PREVIOUS_2_WEEKS":
            dateFilter = {
                start: new Date(moment(startDate).subtract(2, 'weeks').startOf('day').toISOString()),
                end: new Date(moment(endDate).subtract(2, 'weeks').endOf('day').toISOString())
            };
            break;
        case "PREVIOUS_WEEK":
            dateFilter = {
                start: new Date(moment(startDate).subtract(1, 'weeks').startOf('week').toISOString()),
                end: new Date(moment(startDate).subtract(1, 'weeks').endOf('week').toISOString())
            };
            break;
        default:
            break
    }

    return dateFilter;
}
// Current year as a { label, value } option
export const getCurrentYear = () => {
    const year = `${new Date().getFullYear()}`;
    return { label: year, value: year };
}
export const getYears = (dateYear, yearCount = 0, isReverse = true) => {
    let years = []
    let startYear = new Date(dateYear).getFullYear();
    const year = new Date().getFullYear();
    for (let start = startYear; start <= (year + yearCount); start++) {
        years.push({label: `${start}`, value: `${start}`})
    }
    if (isReverse) years.sort((a, b) => (parseInt(a.value) < parseInt(b.value)) ? 1 : (parseInt(a.value) > parseInt(b.value)) ? -1 : 0);
    return years;
}
// getFinancialYears
export const getFinancialYears = (dateYear, count = 0) => {
    const years = [];
    let startYear = new Date(dateYear).getMonth()+1 <= 3 ? new Date(dateYear).getFullYear() - 1 : new Date(dateYear).getFullYear();
    let currentYear = new Date().getMonth()+1 <= 3 ? new Date().getFullYear() - 1 : new Date().getFullYear();
    let endYear = currentYear + (count > 0 && startYear === currentYear ? count : 0);

    for (let year = count < 0 && startYear === currentYear ? startYear - 1 : startYear; year <= endYear; year++) {
        years.push({ label: `${year} - ${year + 1}`, value: `${year} - ${year + 1}` });
    }

    return years.sort((a, b) => parseInt(b.value) - parseInt(a.value));
};
// getPreviousMonth
export const getPreviousMonth = () => {
    return MONTH.LIST?.find(e => e?.value === (new Date()?.getMonth() === 0 ? 1 : new Date()?.getMonth()))
}
// getCurrentMonth
export const getCurrentMonth = () => {
    const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0 for January, adding 1 to align with month numbers
    return MONTH.LIST?.find(e => e?.value === currentMonth);
}
export const getCalendarYears = (dateYear, count = 0) => {
    let years = []
    let startYear = new Date(dateYear)?.getFullYear();
    let year = new Date().getFullYear();
    for (let start = count < 0 && startYear === year ? startYear - 1 : startYear; start <= (year + (count > 0 && startYear === year ? count : 0)); start++) years.push({
        label: `${start}`,
        value: `${start} - ${start}`
    })
    years.sort((a, b) => (parseInt(a.value) < parseInt(b.value)) ? 1 : (parseInt(a.value) > parseInt(b.value)) ? -1 : 0);
    return years;
}

// Extract one side of a year-range value (e.g. "2024 - 2025") by index; tolerant of object/string/spaced inputs
export const getSeparateYears = (yearTds, index, key) => {
    if (!yearTds) return null;
    let yearString = '';

    if (yearTds[key]) {
        yearString = yearTds[key];
    } else if (yearTds?.value) {
        yearString = yearTds.value;
    } else if (typeof yearTds === 'string') {
        yearString = yearTds;
    }

    const yearParts = yearString.replace(/\s+/g, '').split('-');

    return yearParts[index] || null;
}

